import Vue from 'vue'

export default {
    resetStateMutation(state) {
        Vue.set(state, "doctorConsultConfigIsShow", true);
        Vue.set(state, "doctorConsultTableIsShow", true);
        Vue.set(state, "doctorConsultFormIsShow", false);
        Vue.set(state, "doctorHolidayIsShow", false);
        Vue.set(state, "doctorHolidayTableIsShow", true);
        Vue.set(state, "doctorHolidayFormIsShow", false);
    },
    showDoctorConsultConfig(state) {
        state.doctorConsultConfigIsShow = true;
        state.doctorHolidayIsShow = false;
    },
    showDoctorConsultTable(state) {
        state.doctorConsultTableIsShow = true;
        state.doctorConsultFormIsShow = false;
    },
    showDoctorConsultForm(state) {
        state.doctorConsultTableIsShow = false;
        state.doctorConsultFormIsShow = true;
    },
    showDoctorHoliday(state) {
        state.doctorConsultConfigIsShow = false;
        state.doctorHolidayIsShow = true;
    },
    showDoctorHolidayTable(state) {
        state.doctorHolidayFormIsShow = false;
        state.doctorHolidayTableIsShow = true;
    },
    showDoctorHolidayForm(state) {
        state.doctorHolidayFormIsShow = true;
        state.doctorHolidayTableIsShow = false;
    }
}
